<template>
  <div class="certificate-card-nothing">
    <icon name="question" class="icon-question"></icon>

    <p class="text">暂无健康证明信息</p>
  </div>
</template>

<script>
export default {
  
}
</script>

<style lang="less" scoped>
.certificate-card-nothing {
  display: flex;
  flex-flow: column nowrap;
  justify-content: center;
  align-items: center;
  overflow: hidden;
  margin: 15px;
  padding: 37.5px 0;
  border-radius: 7.5px;
  border: 1px dashed #BBB;
  min-height: 70px;
}

.icon-question {
  width: 50px;
  height: 50px;
  color: #d9d9d9;
}

.text {
  color: #BBB;
  font-size: 15px;
  margin-top: 22.5px;
}
</style>
